// extracted by mini-css-extract-plugin
export default {"basic-panel":"SupplementaryCrosswalkTable_basic-panel__lWqGB","disabled":"SupplementaryCrosswalkTable_disabled__4DqwL"};